/**
 * Generated by orval 🍺
 * Do not edit manually.
 * qcs control-plane
 * OpenAPI spec version: 0.1.0
 */

export type KnobGroup = typeof KnobGroup[keyof typeof KnobGroup];


export const KnobGroup = {
  pool: 'pool',
  pacing: 'pacing',
  scope: 'scope',
  flow: 'flow',
} as const;
